
export class Logger {

  constructor(level) {

  }

  dir(obj: any, options?: any): void {
      console.dir(obj);
  }

  error(message?: any, ...optionalParams: any[]): void {
      console.error(message, ...optionalParams);
  }

  info(message?: any, ...optionalParams: any[]): void {
      // tslint:disable-next-line:no-console
      console.info(message, ...optionalParams);
  }

  log(message?: any, ...optionalParams: any[]): void {
      console.log(message, ...optionalParams);
  }

  trace(message?: any, ...optionalParams: any[]): void {
      // tslint:disable-next-line:no-console
      console.trace(message, ...optionalParams);
  }

  warn(message?: any, ...optionalParams: any[]): void {
      console.warn(message, ...optionalParams);
  }

  time(label: string): void {
      // tslint:disable-next-line:no-console
      if (console.time) {
          // tslint:disable-next-line:no-console
          console.time(label);
      }
  }

  timeEnd(label: string): void {
      // tslint:disable-next-line:no-console
      if (console.timeEnd) {
          // tslint:disable-next-line:no-console
          console.timeEnd(label);
      }
  }
}

export const logger = new Logger('info');
